"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Currency;
const react_1 = __importDefault(require("react"));
const useInputDebounce_1 = __importDefault(require("../hooks/useInputDebounce"));
const monetize = x => (x ? `$${Number(x).toLocaleString()}` : '');
const handleChange = ({ target: { value } }, cb) => {
    cb(value.replace(/\D/g, ''));
};
function Currency({ value, onChange, onBlur, id }) {
    const [val, debounceOnChange, flush] = (0, useInputDebounce_1.default)({ value, onChange });
    return (react_1.default.createElement("input", { value: monetize(val), id: id, onChange: e => handleChange(e, debounceOnChange), onBlur: () => {
            onBlur();
            flush();
        } }));
}
//# sourceMappingURL=Currency.js.map